import cmp from './UnverifiedAccount'

export default cmp
